"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _default = {
  show: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].node,
  subtitle: _propTypes["default"].node,
  iconNavigation: _propTypes["default"].node,
  showCloseButton: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  bsSize: _propTypes["default"].oneOf(['sm', 'md', 'lg', 'xl', 'full', 'fullscreen']),
  disableEsc: _propTypes["default"].bool,
  useOverflow: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
exports["default"] = _default;